import { searchEventSchema } from "@nook/schema";
/** `POST /v1/search` (block 16) — an event stream, not a response body. */
export function search(http, body, signal) {
    return http.stream({
        path: "/v1/search",
        method: "POST",
        body,
        schema: searchEventSchema,
        ...(signal ? { signal } : {}),
    });
}
//# sourceMappingURL=search.js.map